import React, { useContext } from 'react'
import Fade from '@material-ui/core/Fade'
import Box from '@material-ui/core/Box'
import CircularProgress from '@material-ui/core/CircularProgress'

// store
import { Context } from '../store'

const Loading = () => {
  const { globalState } = useContext(Context)
  const { loading } = globalState

  return (
    <Fade
      in={loading}
      style={{
        transitionDelay: loading ? '50ms' : '0ms',
      }}
      unmountOnExit
    >
      <Box textAlign="center" padding={5}>
        <CircularProgress />
      </Box>
    </Fade>
  )
}

export default Loading
